import useSWR from "swr";
import fetcher from "@adora/shared/utils/fetch";
import { RelativeUrl } from "@adora/shared/utils/environment";

export interface ExperimentInfoSchema {
  caption_batch_info: Record<string, unknown> | null;
  training_batch_info: Record<string, unknown> | null;
  product_lora_model_info: Record<string, unknown> | null;
}

export function useExperimentInfo(brandId: number | undefined, experimentId: number | undefined) {
  const url = experimentId && brandId ? `${RelativeUrl}/experiments/${experimentId}/info?brand_id=${brandId}` : null;

  const { data, error, isLoading } = useSWR(url, (url) => fetcher<ExperimentInfoSchema>(url), {
    revalidateOnFocus: false
  });

  return {
    info: data,
    isLoading,
    error
  };
}
